import { render, staticRenderFns } from "./Binder.vue?vue&type=template&id=574c5548&"
import script from "./Binder.vue?vue&type=script&lang=js&"
export * from "./Binder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports